module.exports = __webpack_public_path__ + "img/edit.63d0a7d9.svg";